import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import './index.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Shahab Lashkari's Blog"
      meta={[
        {
          name: 'description',
          content:
            'I try to help people make the web better. These are my thoughts, tips, and development tutorials.',
        },
        {
          name: 'keywords',
          content: 'front-end, web, development, react, html, css',
        },
      ]}
    >
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=UA-29719940-1"
      />
      <script>
        {`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'UA-29719940-1');`}
      </script>
    </Helmet>
    <Header />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js